import { render, staticRenderFns } from "./save-strategy-tpl-modal.vue?vue&type=template&id=781ef6b8&scoped=true&"
import script from "./save-strategy-tpl-modal.vue?vue&type=script&lang=js&"
export * from "./save-strategy-tpl-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781ef6b8",
  null
  
)

export default component.exports